import type { RJSFSchema, UiSchema } from "@rjsf/utils";
import { baseJsonSchema, baseUiSchema } from "@/views/cms/EditorView/mediaSchemas/baseMediaSchema";

const tempJson = JSON.parse(JSON.stringify(baseJsonSchema)) as RJSFSchema;
if (tempJson.properties) {
  tempJson.properties.settings = {
    type: "object",
    properties: {
      volume: {
        type: "integer",
        minimum: 0,
        maximum: 100,
        default: 50,
      },
      thumbnail_override: {
        title: "Thumbnail",
        type: "object",
        properties: {
          mediaId: {
            type: ["integer", "null"],
            default: null,
          },
        },
      },
    },
  };
}
export const audioJsonSchema: RJSFSchema = tempJson;

const tempUi = JSON.parse(JSON.stringify(baseUiSchema)) as UiSchema;
tempUi["ui:order"] = ["general", "metaData", "credits", "settings"];
tempUi.metaData.category["ui:options"] = {
  choices: [
    { value: "", "ui:label": "mediaCategory.none" },
    { value: "music", "ui:label": "mediaCategory.music" },
    { value: "spoken", "ui:label": "mediaCategory.spoken" },
    { value: "sound", "ui:label": "mediaCategory.sound" },
    { value: "other", "ui:label": "mediaCategory.other" },
  ],
};
tempUi.settings = {
  "ui:title": "generic.settings",
  volume: {
    "ui:title": "generic.volume",
    "ui:widget": "RangeWidget",
  },
  thumbnail_override: {
    "ui:field": "MediaSelectorField",
    "ui:title": "editMedia.thumbnail",
    "ui:options": {
      mediaTypes: ["image"],
    },
  },
  "ui:layout": {
    fields: ["volume", "thumbnail_override"],
    template: "Section",
  },
};
export const audioUiSchema: UiSchema = tempUi;
